import React from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes as RoutePath,
} from "react-router-dom";
import BookingStatus from "./pages/BookingStatus";
import BookingSummary from "./pages/BookingSummary";
import LandingPage from "./pages/landingPage/LandingPage";
import AboutUs from "./pages/landingPage/AboutUs";
import ContactUs from "./pages/landingPage/ContactUs";
import MultiItinerary from "./pages/landingPage/MultiItinerary";
import VipAssistance from "./pages/landingPage/VipAssistance";
import UnableTransfer from "./pages/landingPage/UnableTransfer";
import PassengerDetail from "./pages/PassengerDetail";
import PaymentDetail from "./pages/PaymentDetail";
import SearchResult from "./pages/SearchResult";
import Login from "./pages/b2b/auth/login";
import SignUp from "./pages/b2b/auth/SignUp";
import Home from "./pages/b2b/Home";
import NewBooking from "./pages/b2b/NewBooking/NewBooking";
import ManageBooking from "./pages/b2b/ManageBooking";
import Settings from "./pages/b2b/Settings";
import Regions from "./pages/b2b/Regions";
import UserManagement from "./pages/b2b/UserManagement";
import VehicleTypes from "./pages/b2b/VehicleTypes";
import Statistics from "./pages/b2b/Statistics";

import SearchResultB2b from "./pages/b2b/NewBooking/SearchResultB2b";
import PassengerDetailB2b from "./pages/b2b/NewBooking/PassengerDetailB2b";
import BookingSummaryB2b from "./pages/b2b/NewBooking/BookingSummaryB2b";
import BookingStatusB2b from "./pages/b2b/NewBooking/BookingStatusB2b";
import Event from "./pages/b2b/Event";
import Affiliate from "./pages/b2b/Affiliate";
import SingleBookingDetail from "./pages/b2b/SingleBookingDetail";
import CreateRegion from "./pages/b2b/regions/CreateRegion";
import OfflineBooking from "./pages/b2b/OfflineBooking/OfflineBooking";
import OfflineBookingCars from "./pages/b2b/OfflineBooking/OfflineBookingCars";
import EditRegion from "./pages/b2b/regions/EditRegion";
import CreditCards from "./pages/b2b/CreditCard/CreditCards";
import CreditCardDetails from "./pages/b2b/CreditCard/CreditCardDetails";
import Traking from "./pages/Traking";
import Careers from "./pages/landingPage/Careers";
import BookingConditions from "./pages/landingPage/BookingConditions";
import TermsAndConditions from "./pages/landingPage/TermsAndConditions";
import PrivacyPolicy from "./pages/landingPage/PrivacyPolicy";
import Faq from "./pages/landingPage/Faq";
import ForgotPassword from "./pages/landingPage/ForgotPassword";
import ResetPassword from "./pages/landingPage/ResetPassword";
import TripPackage from "./pages/b2b/TripPackage/TripPackage";

import FlatRegions from "./pages/b2b/flatRegion/FlatRegions";
import FlatRegionEdit from "./pages/b2b/flatRegion/FlatRegionEdit";
import FlatRates from "./pages/b2b/FlatBooking/FlatRates";
import FlatRateSearchResult from "./pages/b2b/FlatBooking/FlatRateSearchResult";
import FlatRatePassengerDetail from "./pages/b2b/FlatBooking/FlatRatePassengerDetails";
import FlatrateBookingSummary from "./pages/b2b/FlatBooking/FlatRateBookingSummary";
import Voucher from "./pages/b2b/viewDocuments/Voucher";
import Invoice from "./pages/b2b/viewDocuments/Invoice";
import Dockets from "./pages/b2b/Accounting/Dockets";
import DocketInvoice from "./pages/b2b/Accounting/DocketInvoice";
import InvoiceRecords from "./pages/b2b/Accounting/InvoiceRecords";
import FlatRegionCreate from "./pages/b2b/flatRegion/FlatRegionCreate";
import MainDocs from "./pages/b2b/api_docs_v2/MainDocs";
import FinAmmendment from "./pages/b2b/FinAmmendment";
import OpsAmmendment from "./pages/b2b/OpsAmmendment";
import EditRegiontow from "./pages/b2b/regions/EditRegion2";
import MainDocsPage from "./pages/b2b/WhiteLevellingDocs/MainDocsPage";

const Routes = ({ token }) => {
  return (
    <BrowserRouter>
      <RoutePath>
        <Route path="/" element={<LandingPage />} />

        {/*   ************ B2C pages start ***************** */}
        <Route path="/searchResult" element={<SearchResult />} />
        <Route path="/passengerDetail" element={<PassengerDetail />} />
        <Route path="/bookingSummary" element={<BookingSummary />} />
        <Route path="/payment" element={<PaymentDetail />} />
        <Route path="/bookingStatus" element={<BookingStatus />} />
        <Route path="/aboutUs" element={<AboutUs />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/multiItinerary" element={<MultiItinerary />} />
        <Route path="/vipAssistance" element={<VipAssistance />} />
        <Route path="/unableTransfer" element={<UnableTransfer />} />
        <Route path="/traking/:id" element={<Traking />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/password/reset/:token" element={<ResetPassword />} />

        {/*   ************ B2C pages end ***************** */}

        {/* *************** B2B pages start ******************* */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />

        {token ? (
          <Route path="/home" element={<Home />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
          // navigate("/login")
        )}

        {token ? (
          <Route path="/newbooking" element={<NewBooking />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/trippackage" element={<TripPackage />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/offlinebooking" element={<OfflineBooking />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route
            path="/offlinebooking/vehicles"
            element={<OfflineBookingCars />}
          />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/manageBooking/:id" element={<SingleBookingDetail />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/manageBooking/:id/view/voucher" element={<Voucher />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/manageBooking/:id/view/invoice" element={<Invoice />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route
            path="/newbooking/searchResult"
            element={<SearchResultB2b />}
          />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route
            path="/newbooking/searchResult/passengerDetail"
            element={<PassengerDetailB2b />}
          />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route
            path="/newbooking/searchResult/passengerDetail/bookingSummary"
            element={<BookingSummaryB2b />}
          />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route
            path="/newbooking/searchResult/passengerDetail/bookingSummary/bookingStatus"
            element={<BookingStatusB2b />}
          />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}

        {/* flat rates start */}
        {token ? (
          <Route path="/flatrates" element={<FlatRates />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route
            path="/flatrates/searchResult"
            element={<FlatRateSearchResult />}
          />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route
            path="/flatrate/searchResult/passengerDetail"
            element={<FlatRatePassengerDetail />}
          />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route
            path="/flatrate/searchResult/passengerDetail/bookingSummary"
            element={<FlatrateBookingSummary />}
          />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {/* flat rates end */}
        {token ? (
          <Route path="/manageBooking" element={<ManageBooking />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}

        {/* Accounting Start*/}
        {token ? (
          <Route path="/docket" element={<Dockets />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/docketInvoice" element={<DocketInvoice />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/docketInvoice/records" element={<InvoiceRecords />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/docketInvoice/:id" element={<DocketInvoice />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/docketInvoice" element={<DocketInvoice />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {/* Accounting End */}

        {token ? (
          <Route path="/settings" element={<Settings />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/regions" element={<Regions />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/flatregions" element={<FlatRegions />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/regions/edit/:id" element={<EditRegion />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}

        {token ? (
          <Route path="/regions2/edit/:id" element={<EditRegiontow />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/flatregions/edit/:id" element={<FlatRegionEdit />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/regions/create" element={<CreateRegion />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/flatregions/create" element={<FlatRegionCreate />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/usermanagement" element={<UserManagement />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/statistics" element={<Statistics />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/vehicletype" element={<VehicleTypes />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/creditcard" element={<CreditCards />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/creditcard/:id" element={<CreditCardDetails />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}

        {token ? (
          <Route path="/apidocs" element={<MainDocs />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}

        {token ? (
          <Route path="/wldocs" element={<MainDocsPage/>} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}

        {/* TODO: compnonent name and route name should change */}
        {token ? (
          <Route path="/Event" element={<Event />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route path="/affiliate" element={<Affiliate />} />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {token ? (
          <Route
            path="/manageBooking/opsAmendment"
            element={<OpsAmmendment />}
          />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}

        {token ? (
          <Route
            path="/manageBooking/finAmendment"
            element={<FinAmmendment />}
          />
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
        {/* *************** B2B pages end ******************* */}

        {/* ------------------------- Footer link --------------------------- */}
        <Route path="/careers" element={<Careers />} />
        <Route path="/bookingConditions" element={<BookingConditions />} />
        <Route path="/termsAndConditions" element={<TermsAndConditions />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/faq" element={<Faq />} />
        {/* ------------------------- Footer linK ---------------------------- */}
      </RoutePath>
    </BrowserRouter>
  );
};

export default React.memo(Routes);
